import React__default from 'react';

var Triangle3 = function Triangle3(props) {
  var className = props.className,
    style = props.style;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: className,
    style: style,
    width: "38",
    height: "63",
    viewBox: "0 0 38 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "38",
    height: "63"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "38",
    height: "63",
    fill: "#4AEAEB"
  })), /*#__PURE__*/React__default.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M38 4.63671V58.379C37.9972 59.1874 37.7852 59.9809 37.3851 60.681C36.985 61.3811 36.4106 61.9634 35.7189 62.3702C35.0273 62.7769 34.2423 62.994 33.442 62.9999C32.6416 63.0057 31.8536 62.8002 31.1562 62.4037L-15.6891 35.5216C-16.3912 35.1158 -16.9747 34.5299 -17.3805 33.8231C-17.7863 33.1164 -18 32.3139 -18 31.4969C-18 30.6799 -17.7863 29.8775 -17.3805 29.1707C-16.9747 28.464 -16.3912 27.8781 -15.6891 27.4723L31.1562 0.612058C31.8526 0.208521 32.642 -0.00257517 33.4449 2.37097e-05C34.2478 0.00262259 35.0359 0.218825 35.7297 0.626862C36.4236 1.0349 36.9987 1.62037 37.3973 2.32431C37.7958 3.02825 38.0037 3.82582 38 4.63671Z",
    fill: "#4AEAEB"
  })));
};
Triangle3.defaultProps = {
  className: undefined,
  style: undefined
};
var Triangle3$1 = Triangle3;

export { Triangle3$1 as default };
